import React from "react"
import { Typography } from "@material-ui/core"

import useStyles from "@/pages/Attendance/Chat/ConversationPanel/MessageList/FlowResponseContent/styles"
import { IMessageExtraData } from "@/protocols/channel"

type FlowResponseContentProps = {
	flowResponse: NonNullable<IMessageExtraData["flowResponse"]>
}

const FlowResponseContent: React.FC<FlowResponseContentProps> = (props) => {
	const { flowResponse } = props

	const classes = useStyles()

	let parsedResponse: Record<string, unknown> | null = null

	try {
		parsedResponse = JSON.parse(flowResponse.responseJson) as Record<string, unknown>
	} catch {
		return null
	}

	const entries = Object.entries(parsedResponse)

	if (!entries.length) {
		return null
	}

	return (
		<Typography
			variant="overline"
			className={classes.flowResponseText}
		>
			{entries.map(([key, value], index) => (
				<span key={index} className={classes.flowResponseLine}>
					<strong>{key}:</strong> {String(value)}
				</span>
			))}
		</Typography>
	)
}

export default FlowResponseContent
